import { Injectable } from '@angular/core';
import {
  GenericDataResponse,
  HemsFeaturesPresentSincePayload,
  HemsFeaturesPresentSinceResponse,
} from '../analytics/analytics.model';

@Injectable({ providedIn: 'root' })
export class MockedDeviceAvailableHemsProperties {
  mock(
    body: HemsFeaturesPresentSincePayload
  ): GenericDataResponse<HemsFeaturesPresentSinceResponse> {
    return {
      data: {
        gateway_id: body.gateway_id,
        device_id: 'HEMS',
        properties: [
          {
            property: 'ems.energy.consumption.heat-pump',
            start_datetime: '2023-08-28T15:34:29+02:00',
          },
          {
            property: 'ems.energy.storage.to.storage',
            start_datetime: '2023-08-28T15:34:29+02:00',
          },
          { property: 'ems.energy.storage.to.grid', start_datetime: '2023-08-28T15:34:29+02:00' },
          {
            property: 'ems.energy.storage.to.consumption',
            start_datetime: '2023-08-28T15:34:29+02:00',
          },
          { property: 'ems.energy.storage.discharge', start_datetime: '2023-08-28T15:34:29+02:00' },
          { property: 'ems.energy.storage.charge', start_datetime: '2023-08-28T15:34:29+02:00' },
          { property: 'ems.energy.production.total', start_datetime: '2023-08-28T15:34:29+02:00' },
          {
            property: 'ems.energy.production.to.storage',
            start_datetime: '2023-08-28T15:34:29+02:00',
          },
          {
            property: 'ems.energy.production.to.grid',
            start_datetime: '2023-08-28T15:34:29+02:00',
          },
          {
            property: 'ems.energy.production.to.consumption',
            start_datetime: '2023-08-28T15:34:29+02:00',
          },
          {
            property: 'ems.energy.production.photovoltaic',
            start_datetime: '2023-08-28T15:34:29+02:00',
          },
          { property: 'ems.energy.grid.to.storage', start_datetime: '2023-08-28T15:34:29+02:00' },
          {
            property: 'ems.energy.grid.to.consumption',
            start_datetime: '2023-08-28T15:34:29+02:00',
          },
          { property: 'ems.energy.grid.feed-in', start_datetime: '2023-08-28T15:34:29+02:00' },
          { property: 'ems.energy.grid.consumption', start_datetime: '2023-08-28T15:34:29+02:00' },
          { property: 'ems.energy.consumption.vcs', start_datetime: '2023-08-28T15:34:29+02:00' },
          { property: 'ems.energy.consumption.total', start_datetime: '2023-08-28T15:34:29+02:00' },
          {
            property: 'ems.energy.consumption.household',
            start_datetime: '2023-08-28T15:34:29+02:00',
          },
          { property: 'ems.kpi.autarky', start_datetime: '2023-08-28T15:34:29+02:00' },
          { property: 'ems.kpi.self-consumption', start_datetime: '2023-08-28T15:34:29+02:00' },
        ],
      },
    };
  }
}
